import React from "react";

function NoImage() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 100 100"
    >
      <linearGradient
        id="b"
        x1="50"
        x2="50"
        y1="0"
        y2="100"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#19afff"></stop>
        <stop offset="1" stopColor="#0062e0"></stop>
      </linearGradient>
      <clipPath id="a">
        <path d="M0 0h100v100H0z" data-original="#000000"></path>
      </clipPath>
      <g clipPath="url(#a)">
        <rect
          width="100"
          height="100"
          fill="url(#b)"
          data-original="url(#b)"
          rx="10"
        ></rect>
        <path
          fill="#fff"
          d="M71.375 76.875L66.937 72.5H31.25c-1.042 0-1.927-.365-2.656-1.094-.73-.729-1.094-1.614-1.094-2.656V33.062l-3.813-3.812a1.73 1.73 0 01-.53-1.344c.02-.52.218-.969.593-1.344S24.562 26 25.062 26s.938.188 1.313.563L74 74.25c.375.375.562.813.562 1.313s-.187.937-.562 1.312-.813.563-1.313.563-.937-.188-1.312-.563zM37.062 61.25h18.625l-5.312-5.375-2.875 3.438-4.313-5.876c-.208-.25-.448-.374-.718-.374s-.51.104-.72.312l-5.437 6.313c-.25.333-.291.677-.125 1.03.167.355.459.532.875.532zM72.5 67.375L32.625 27.5H68.75c1.042 0 1.927.365 2.656 1.094.73.729 1.094 1.614 1.094 2.656z"
          data-original="#ffffff"
        ></path>
      </g>
    </svg>
  );
}

export default NoImage;
